import { createAction } from 'redux-actions'
import {
  ILocalStats,
  IRemoteStats,
  JitsiConference,
  JitsiLocalTrack,
  JitsiParticipant,
  JitsiRemoteTrack,
} from 'lib-jitsi-meet'

export const initRoom = createAction<void>('INIT_ROOM')

export const setJitsiRoom = createAction<JitsiConference>('SET_JITSI_ROOM')
export const disposeConference = createAction<void>('DISPOSE_CONFERENCE')
export const leaveRoom = createAction<void>('LEAVE_ROOM')

export const setParticipantIdForUser = createAction<{ participantId: string; userId: number }>(
  'SET_PARTICIPANT_ID_FOR_USER'
)
export const openCallPreviewDialog = createAction<void>('OPEN_CALL_PREVIEW_DIALOG')
export const closeCallPreviewDialog = createAction<void>('CLOSE_CALL_PREVIEW_DIALOG')

export const resetCallLeavingInProgress = createAction<void>('RESET_CALL_LEAVING_IN_PROGRESS')
export const onJitsiInitialized = createAction<void>('ON_JITSI_INITIALIZED')
export const onJitsiDeinitialized = createAction<void>('ON_JITSI_DEINITIALIZED')

export const bindRoomEvents = createAction<void>('BIND_ROOM_EVENTS')
export const unBindRoomEvents = createAction<void>('UNBIND_ROOM_EVENTS')

// Events
export const onTrackAdded = createAction<JitsiLocalTrack | JitsiRemoteTrack>('ON_TRACK_ADDED')
export const onTrackRemoved = createAction<JitsiLocalTrack | JitsiRemoteTrack>('ON_TRACK_REMOVED')

export const onKicked = createAction<[kickedBy: JitsiParticipant, reason: string]>('ON_KICKED')

export const onUserLeft =
  createAction<[participantId: string, participant: JitsiParticipant, reason?: string]>('ON_USER_LEFT')
export const onUserJoined = createAction<[participantId: string, participant: JitsiParticipant]>('ON_USER_JOINED')

export const onConferenceJoined = createAction<void>('ON_CONFERENCE_JOINED')
export const onConferenceFailed = createAction<[string, { msg?: string } | undefined]>('ON_CONFERENCE_FAILED')
export const onTracksInitializationFailed = createAction<[string]>('ON_TRACKS_INITIALIZATION_ERROR')

export const trackAudioLevelChanged =
  createAction<[participantId: string, audioLevel: number]>('TRACK_AUDIO_LEVEL_CHANGED')
export const showSpeaker = createAction<[participantId: string, audioLevel: number]>('SHOW_SPEAKER')

export const localStatsReceived = createAction<ILocalStats>('LOCAL_STATS_RECEIVED')
export const remoteStatsReceived = createAction<[participantId: string, stats: IRemoteStats]>('REMOTE_STATS_RECEIVED')
